import { Component, inject, OnInit } from '@angular/core';
import { FormControl, ValidatorFn } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'empathy-source-picker',
  templateUrl: 'source-picker.component.html',
  styleUrls: ['./source-picker.component.scss']
})
export class SourcePickerComponent implements OnInit {
  sourceTitle = new FormControl<string>('', [this.duplicateTitleValidator()]);

  dirtyErrorMatcher: ErrorStateMatcher = {
    isErrorState: (control) => !!control?.invalid && !!control?.dirty
  };

  private readonly data = inject<{ existingSourceTitles: string[] }>(MAT_DIALOG_DATA);

  constructor(private dialogRef: MatDialogRef<SourcePickerComponent>) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-source-picker__dialog');
  }

  onContinue(): void {
    this.dialogRef.close(this.sourceTitle.value);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  private duplicateTitleValidator(): ValidatorFn {
    return (control) => {
      const title = control.value?.trim().toLowerCase();
      const isDuplicate = !!title && this.data.existingSourceTitles.some((t) => t.trim().toLowerCase() === title);
      return isDuplicate ? { duplicate: true } : null;
    };
  }
}
